/**
 * Account-wide bonuses contributed by feature systems (Haven research,
 * titles…). Core game code asks `accountBonus(key)`; features register
 * providers at install time, so the dependency points from features to the game.
 */
export type BonusKey = 'potionHeal' | 'temperSilver' | 'lifeEnergyCost' | 'battleItemLimit';

const providers: ((key: BonusKey) => number)[] = [];

export function addBonusProvider(fn: (key: BonusKey) => number): void {
  providers.push(fn);
}

/** Sum of every provider's bonus for `key` (fractions, e.g. 0.1 = +10%). */
export function accountBonus(key: BonusKey): number {
  let total = 0;
  for (const p of providers) total += p(key) || 0;
  return total;
}
